import { useState } from "react";
import { DownOutlined, UpOutlined } from "@ant-design/icons";

const SplitByItemCollapsible = ({ data, order, columns }) => {
  const [expandedRows, setExpandedRows] = useState({});

  const toggleRowExpansion = (id) => {
    setExpandedRows((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  // Check if column with key "id" already exists
  const checkColumnExists = columns.some((col) => col.key === "id");

  // If it doesn't exist, then add it
  if (!checkColumnExists) {
    columns.unshift({
      title: "Check",
      dataIndex: "id",
      key: "id",
      render: (text, record, _, index) => {
        return (
          <div
            style={{ display: "flex", alignItems: "center", cursor: "pointer" }}
            onClick={() => toggleRowExpansion(index)}
          >
            <span style={{ color: "#30649b" }}>{text}</span>
            {record.children && record.children.length > 0 && (
              <button
                className="expand-button"
                style={{ color: "#30649b", fontWeight: 900 }}
              >
                {expandedRows[index] ? <UpOutlined /> : <DownOutlined />}
              </button>
            )}
          </div>
        );
      },
    });
  }
  return (
    <div className="custom-table-container">
      <div className="custom-table">
        {/* Table Header */}
        <div className="custom-table-row header">
          {columns.map((table, index) => {
            return (
              <div key={index} className="custom-table-cell">
                {table.title}
              </div>
            );
          })}
        </div>

        {/* Table Rows */}
        {data.map((record, index) => (
          <div key={record.key} className="custom-table-row-container">
            {/* Main Row */}
            <div className="custom-table-row">
              {columns.map((column) => {
                // Get the value from the record
                const value = record[column.dataIndex];

                // Use the column's render function if it exists, otherwise just display the value
                return (
                  <div key={column.key} className="custom-table-cell">
                    {column.render
                      ? column.render(value, record, order, index)
                      : value}
                  </div>
                );
              })}
            </div>

            {/* Expanded Content */}
            {expandedRows[index] &&
              record.children &&
              record.children.length > 0 && (
                <>
                  <div className="custom-table-row header">
                    {record.children.length > 0 &&
                      Object.keys(record.children[0])

                        .map((key, index) => (
                          <div
                            key={index}
                            className="custom-table-cell capitalize"
                            style={{
                              fontWeight: 500,
                              textTransform: "capitalize",
                            }}
                          >
                            {key == "key" ? "" : key}
                          </div>
                        ))}
                  </div>
                  <div className="expanded-content">
                    {record.children.map((item) => (
                      <div key={item.key} className="item-row">
                        <div className="custom-table-cell" />
                        <div className="custom-table-cell">
                          <strong>
                            ${item.amount ? item.amount.toFixed(2) : "-"}
                          </strong>
                        </div>
                        <div className="custom-table-cell">
                          <strong>
                            {item.discount
                              ? "$" + item.discount.toFixed(2)
                              : "-"}
                          </strong>
                        </div>
                        <div className="custom-table-cell">
                          <strong>
                            {item.tax ? "$" + item.tax.toFixed(2) : "-"}
                          </strong>
                        </div>
                        <div className="custom-table-cell">{item.item}</div>
                        <div className="custom-table-cell">
                          <strong>
                            {item.tip ? "$" + item.tip.toFixed(2) : "-"}
                          </strong>
                        </div>
                      </div>
                    ))}
                  </div>
                </>
              )}
          </div>
        ))}
      </div>

      <style jsx>{`
        .custom-table-container {
          border-bottom: 1px solid #e0e0e0;
          overflow: hidden;
          margin-bottom: 16px;
          background: white;
          font-weight: 500;
        }

        .custom-table-header {
          padding: 16px;
          background: #fafafa;
          border-bottom: 1px solid #e0e0e0;
        }

        .custom-table-header h2 {
          margin: 0;
          font-size: 16px;
          font-weight: 500;
        }

        .custom-table {
          width: 100%;
        }

        .custom-table-row {
          display: flex;
          width: 100%;
          border-bottom: 1px solid #f0f0f0;
        }

        .custom-table-row.header {
          background: #f5f5f5;
          font-weight: 500;
        }

        .custom-table-cell {
          flex: 1;
          padding: 12px 16px;
          display: flex;
          align-items: center;
        }

        .custom-table-row-container:last-child .custom-table-row {
          border-bottom: none;
        }

        .expand-button {
          background: none;
          border: none;
          cursor: pointer;
          margin-right: 8px;
          width: 24px;
          height: 24px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 4px;
          font-size: 10px;
        }

        .expand-button:hover {
          background: #f0f0f0;
        }

        .expanded-content {
          background: #fafafa;

          border-bottom: 1px solid #f0f0f0;
        }

        .item-row {
          display: flex;
          justify-content: space-between;

          width: 100%;
        }

        .item-row:not(:last-child) {
          border-bottom: 1px solid #f0f0f0;
        }

        .item-amount {
          font-weight: 500;
        }

        .item-name {
          color: #666;
        }

        @media (max-width: 768px) {
          .custom-table-row {
            flex-direction: column;
          }

          .custom-table-cell {
            padding: 8px 16px;
          }
        }
      `}</style>
    </div>
  );
};

// Example usage with sample data

export default SplitByItemCollapsible;
